/**
 * Adjunta el HTML de un editor enriquecido a un FormData como parte de fichero.
 *
 * El WAF del Application Gateway que hay delante de producción responde 403 a
 * cualquier campo de formulario cuyo valor contenga un `<...>`, y la petición ni
 * siquiera llega a Laravel. Eso impedía crear y editar noticias, artículos y
 * términos, porque lo que genera el editor es HTML.
 *
 * Las partes de fichero de un multipart no las inspecciona: pasan aunque lleven
 * HTML. Por eso el cuerpo viaja como fichero `<campo>_html` y el middleware
 * MergeRichTextUploads del backend lo vuelve a dejar en `<campo>` antes de validar,
 * de modo que la API sigue recibiendo exactamente lo mismo que antes.
 *
 * @param {FormData} formData
 * @param {string} field  nombre del campo tal y como lo espera la API ('body', 'body2'...)
 * @param {string} html   contenido del editor
 */
export function appendRichText(formData, field, html) {
    formData.append(
        field + '_html',
        new Blob([html ?? ''], { type: 'text/html' }),
        field + '.html'
    )
}

export default appendRichText
